module.exports = __webpack_public_path__ + "img/Patrice.700e5c00.jpeg";